import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AuthService, ProductScope, ProductService } from '@spartacus/core'
import { Observable, Subject } from 'rxjs'
import { filter, take } from 'rxjs/operators'
import { ErrorTypes } from '../../../models/enum/error.enum'
import { ErrorMessage } from '../../../models/error.model'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { UserPermissionService } from '../../../services/user-permission/user-permission.service'

@Component({
    selector: 'app-compare-products',
    templateUrl: './compare-products.component.html',
    styleUrls: ['./compare-products.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompareProductsComponent implements OnInit {
  private readonly onDestroy = new Subject<void>()
  public products: ICustomProduct[] = []
  public errorMessage: ErrorMessage = new ErrorMessage()
  public noProductCode = false
  isLoggedIn$: Observable<boolean>
  constructor(
    private readonly route: ActivatedRoute,
    private productService: ProductService,
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService,
    public userPermissionService: UserPermissionService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isUserLoggedIn()
    // TODO:Spartacus - The 'get' method's signature changed to: 'get(  productCode: string,  scopes: (ProductScope | string)[] | ProductScope | string): Observable<Product | undefined>'
    const productcodes: string = this.route.snapshot.queryParamMap.get('productcodes')
    if (productcodes && productcodes.length > 0) {
      const productcodesArray: string[] = this.generateProductCodeArray(productcodes)
      this.getProducts(productcodesArray)
      this.noProductCode = false
    } else {
      this.noProductCode = true
    }
    this.makeErrorMessage()
  }

  makeErrorMessage(): void {
    this.errorMessage.title = 'No products have been selected'
    this.errorMessage.message = 'Try selecting some items from category page'
    this.errorMessage.buttonMessage = 'Return to category page'
    this.errorMessage.type = ErrorTypes.productNotFound
    this.errorMessage.url = 'Brands/all/c/brands'
  }

  generateProductCodeArray(productcodes: string): string[] {
    return productcodes.split(',')
  }

  getProducts(productCodes: string[]): void {
    productCodes.forEach((productCode) => {
      this.productService
        // TODO:Spartacus - The 'get' method's signature changed to: 'get(  productCode: string,  scopes: (ProductScope | string)[] | ProductScope | string): Observable<Product | undefined>'
        .get(productCode, ProductScope.DETAILS)
        .pipe(filter(Boolean), take(1))
        .subscribe((product: ICustomProduct) => {
          this.products.push(product)
          this.changeDetectorRef.detectChanges()
        })
    })
  }
}
